<div class="ui-multiselected-item-token">
            <span *ngIf='items && items.length > 1' title='{{items.length}} {{"multiselect.text"|translate}}'>
              {{items.length}} {{"multiselect.text"|translate}}
            </span>
  <span *ngIf='items && items.length == 1' title='{{items[0].value.label | translate}}'>{{items[0].value.label | translate}}</span>
</div>
<span *ngIf="!items || items.length === 0"
      class="ui-multiselected-empty-token" title="{{emptyMessage|translate}}">{{emptyMessage|translate}}</span>
